import { useCookies } from "react-cookie";

export const useAuthenticated = (): boolean => {
  const [cookies] = useCookies();
  return !!cookies.is_authenticated;
};
